import { Injectable } from '@angular/core';
import { BaseService } from '../../acore/base';
import { HttpService } from '../../acore/services';
import { SessionObject, UrlConstants } from 'src/app/acore/utility';
import { UserDetails } from '../login/core-login/user-details.model';
import { interval, of, Subscription } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
@Injectable()

export class DesktopService extends BaseService {
      userDetails: UserDetails
      private tokenRefreshSubscription: Subscription;

      applyTheme = null;
      constructor(
            protected http: HttpService
      ) {
            super(http);
      }

      ngOnInit() {
            this.startTokenRefreshTimer()
      }

      startTokenRefreshTimer() {
            // console.log("hi timer started")
            const refreshCheckInterval = 60 * 1000;
            const refreshThreshold = 55 * 60 * 1000;

            if (this.tokenRefreshSubscription) {
                  this.tokenRefreshSubscription.unsubscribe();
            }

            this.tokenRefreshSubscription = interval(refreshCheckInterval).subscribe(() => {
                  const loginTimestamp = sessionStorage.getItem('LOGIN_TIMER');
                  if (!loginTimestamp) {
                        console.warn('No login timestamp found');
                        return;
                  }

                  const loginTime = parseInt(loginTimestamp, 10);
                  const now = Date.now();
                  const elapsed = now - loginTime;

                  if (elapsed >= refreshThreshold) {
                        this.refreshAuthToken().subscribe(() => {
                              sessionStorage.setItem('LOGIN_TIMER', now.toString()); // reset login timer
                        });
                  }
            });
      }

      refreshAuthToken() {
            const userDetails = SessionObject.getUserDetails();
            if (!userDetails || !userDetails.Token) {
                  console.warn('No token found to refresh');
                  return of(null);
            }

            return this.refreshToken(userDetails.Token).pipe(
                  tap((data: any) => {
                        if (data && data.isSuccess && data.token) {
                              userDetails.Token = data.token;
                              SessionObject.setUserDetails(userDetails);
                              console.log('Token refreshed successfully');
                        } else {
                              console.error('Token refresh failed');
                        }
                  }),
                  catchError((error) => {
                        console.error('Error refreshing token:', error);
                        return of(null);
                  })
            );
      }

      refreshToken(oldToken: string) {
            this.userDetails = SessionObject.getUserDetails();

            const headers = {Authorization: `Bearer ${oldToken}`,};

            const params ='uname=' +this.userDetails.userName +'&upass=' +this.userDetails.password +'&grecaptcharesponse';
            return this.http.extractPostData(UrlConstants.LOGIN, params, { headers });
      }
}
